import { render, staticRenderFns } from "./priority-v2.vue?vue&type=template&id=0f95570e&"
import script from "./priority-v2.vue?vue&type=script&lang=ts&"
export * from "./priority-v2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports